"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APP_TYPE = void 0;
const APP_TYPE = exports.APP_TYPE = {
  WX: 1,
  DD: 2
};